import { render, staticRenderFns } from "./budget-item-details.vue?vue&type=template&id=2304c4c7&scoped=true"
import script from "./budget-item-details.vue?vue&type=script&lang=js"
export * from "./budget-item-details.vue?vue&type=script&lang=js"
import style0 from "./budget-item-details.vue?vue&type=style&index=0&id=2304c4c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304c4c7",
  null
  
)

export default component.exports